export const suitesData = [
  {
    id: 'standard',
    name: 'Apartamento Standard',
    subtitle: 'Conforto e Elegância',
    price: '',
    priceNote: '',
    mainImage: 'https://lh3.googleusercontent.com/u/0/d/1Ak9WIKXq4CftC8c87wHK_8242-AZn1o-',
    gallery: [
      'https://lh3.googleusercontent.com/u/0/d/1Ak9WIKXq4CftC8c87wHK_8242-AZn1o-', // Corrigido erro de https://https://
      'https://lh3.googleusercontent.com/u/0/d/1kCI8xQRVsF5JWh3cqhz-1oT1eMJBQlNY',
      'https://lh3.googleusercontent.com/u/0/d/1qlVWxrXRsp0jWBby5MO2JxVDmYnPSLvx'
    ],
    description: 'Nosso Apartamento Standard oferece uma experiência acolhedora com decoração que combina o charme colonial de Ouro Preto com o conforto moderno. Ideal para casais ou viajantes solo que buscam uma estadia confortável.',
    area: '25m²',
    capacity: '2 pessoas',
    amenities: [
      'Cama de casal confortável',
      'TV LED com canais a cabo',
      'WiFi de alta velocidade',
      'Frigobar',
      'Banheiro privativo com chuveiro quente',
      'Cofre',
      'Café da manhã incluso'
    ]
  },
  {
    id: 'junior',
    name: 'Suíte Junior',
    subtitle: 'Espaço e Sofisticação',
    price: '',
    priceNote: '',
    mainImage: 'https://lh3.googleusercontent.com/u/0/d/12BCTUxJ842f6s7syaKfoYfMABdB6hYgb',
    gallery: [
      'https://lh3.googleusercontent.com/u/0/d/12BCTUxJ842f6s7syaKfoYfMABdB6hYgb', // Corrigido erro de https://https://
      'https://lh3.googleusercontent.com/u/0/d/17wV3fAjOcIcT7Fh3vhpJrf1_wuvae80F',
      'https://lh3.googleusercontent.com/u/0/d/1wyNuFuEWs3n8mPwVL0cutinlrAh6uBVs'
    ],
    description: 'A Suíte Junior é perfeita para quem busca mais espaço e conforto. Com área ampla e decoração refinada, oferece um ambiente relaxante com toques de luxo que remetem à história de Ouro Preto.',
    area: '32m²',
    capacity: '2-3 pessoas',
    amenities: [
      'Cama king-size premium',
      'Área de estar confortável',
      'Smart TV 32"',
      'WiFi',
      'Frigobar',
      'Cofre',
      'Banheiro espaçoso',
      'Varanda privativa',
      'Café da manhã incluso'
    ]
  },
  {
    id: 'executiva',
    name: 'Suíte Executiva',
    subtitle: 'Requinte e Exclusividade',
    price: '',
    priceNote: '',
    mainImage: 'https://lh3.googleusercontent.com/u/0/d/1TY9ZBQM_ALZfQ5KZUja2lH1JUc3Ery4j',
    gallery: [
      'https://lh3.googleusercontent.com/u/0/d/1TY9ZBQM_ALZfQ5KZUja2lH1JUc3Ery4j',
      'https://lh3.googleusercontent.com/u/0/d/13hFtwD83BBXpUN3VWFcLpP4vYB5zJgLy',
      'https://lh3.googleusercontent.com/u/0/d/1HUge2D5B8fLbDUE2kpwL4rU1IkuJglm_'
    ],
    description: 'Nossa Suíte Executiva é projetada para viajantes exigentes que valorizam conforto premium e serviços diferenciados. Com vista privileged e decoração elegante, é ideal para estadias prolongadas.',
    area: '42m²',
    capacity: '2-3 pessoas', // Corrigido para 2-3 pessoas
    amenities: [
      'Cama king-size premium',
      'TV 32"',
      'WiFi ultra-rápido',
      'Cofre digital',
      'Varanda ampla com vista',
      'Café da manhã incluso',
      'Banheiro de luxo',
      'Serviço de quarto',
      'Móveis Coloniais'
    ]
  },
  {
    id: 'master',
    name: 'Suíte Master',
    subtitle: 'O Máximo em Luxo',
    price: '',
    priceNote: '',
    mainImage: 'https://lh3.googleusercontent.com/u/0/d/19DGOGlOMpGqBviLnfYvqfQ6w4Zk7O6IS',
    gallery: [
      'https://lh3.googleusercontent.com/u/0/d/19DGOGlOMpGqBviLnfYvqfQ6w4Zk7O6IS',
      'https://lh3.googleusercontent.com/u/0/d/1VhSSgXPhuB2xhooY4Qfbud0fP6Whdw4a',
      'https://lh3.googleusercontent.com/u/0/d/1GtW6_qcKs0erkd_ouEyurqtdTlL3hZh8',
      'https://lh3.googleusercontent.com/u/0/d/1HvYsWeZHM-7l0qP6hL6DpRaA8XDD_-eO'
    ],
    description: 'A Suíte Master é nossa acomodação mais luxuosa e exclusiva. Com design sofisticado, espaço generoso e todas as comodidades imagináveis, proporciona uma experiência inesquecível no coração de Ouro Preto.',
    area: '60m²',
    capacity: '2-3 pessoas', // Corrigido para 2-3 pessoas
    amenities: [
      'Quarto principal com cama king-size',
      'TV 32" com Sky',
      'WiFi de alta velocidade',
      'Cofre',
      'Banheiro master',
      'Varanda panorâmica',
      'Serviço de quarto dedicado',
      'Café da manhã incluso',
      'Móveis Coloniais'
    ]
  }
];
